import React, { useEffect, useState } from 'react';

import {
  Book,
  Building,
  Province,
  Sos,
  Survey,
} from '../@types/KingdomResponse';
import { useIntelState } from '../context/IntelState';

const getBookNames = (sos: Sos) => {
  const names: string[] = [];
  sos.books.forEach((element: Book) => {
    names.push(element.type);
  });
  return names;
};
const getBuildingNames = (survey: Survey) => {
  const names: string[] = [];
  survey.buildings.forEach((element: Building) => {
    names.push(element.name);
  });
  return names;
};

export default function useBuildingBookNames() {
  const { intelState } = useIntelState();
  const [bookNames, setBookNames] = useState<string[] | undefined>(undefined);
  const [buildNames, setBuildNames] = useState<string[] | undefined>(undefined);
  useEffect(() => {
    if (!bookNames) {
      const provWithSci: Province | undefined =
        intelState.ownData?.provinces.find((x) => x.sos !== undefined) ??
        intelState.enemyData?.provinces.find((x) => x.sos !== undefined);
      if (provWithSci && provWithSci.sos) {
        setBookNames(getBookNames(provWithSci.sos));
      }
    }
    if (!buildNames) {
      const max = intelState.ownData?.provinces
        .filter((p) => p.survey !== undefined)
        .reduce((a: any, b: any) => Math.max(b.survey.buildings.length, a), 0);
      const provWithSurvey: Province | undefined =
        intelState.ownData?.provinces.find(
          (x) => x.survey !== undefined && x.survey?.buildings.length === max
        );
      if (provWithSurvey && provWithSurvey.survey) {
        setBuildNames(getBuildingNames(provWithSurvey.survey));
      }
    }
  }, [intelState.ownData, intelState.enemyData, bookNames, buildNames]);

  return [bookNames, buildNames];
}
